module.exports = __webpack_public_path__ + "img/childImg.04656e71.png";